import { render, staticRenderFns } from "./BankDeposits.vue?vue&type=template&id=4e63345a&scoped=true&"
import script from "./BankDeposits.vue?vue&type=script&lang=js&"
export * from "./BankDeposits.vue?vue&type=script&lang=js&"
import style0 from "./BankDeposits.vue?vue&type=style&index=0&id=4e63345a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e63345a",
  null
  
)

export default component.exports